import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { THEFT_REGISTRIES_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updateTheftRegistryStatusAction = createAsyncThunk(
    'order/updateTheftRegistryStatusAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.patch(`${ THEFT_REGISTRIES_PATH }/${ data.id }/status?status=${ data.status }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateTheftRegistryStatusSlice = createSlice({
    name: 'updateTheftRegistryStatusSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateTheftRegistryStatusAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateTheftRegistryStatusAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateTheftRegistryStatusAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateTheftRegistryStatusState = (state) => state.order.updateTheftRegistryStatus;
export default updateTheftRegistryStatusSlice.reducer;
